import React from 'react'
import SelectField from 'material-ui-legacy/SelectField'
import MenuItem from 'material-ui-legacy/MenuItem'
import LinearLoader from '../UI/LinearLoader'

import Resource from '../../stores/resource'

/*
Props:
- resourceAPIEndpoint: The resource api endpoint (e.g. "agencies")
- resourcePluralName: Plural name of resource (e.g. "agencies")
- filter: filters to be used on Resource.findAll()
- unselectedLabel: Unselected option display text (default: `All ${resourcePluralName}``)
- nameAttribute: attribute to be displayed in select options (default: 'name')
- nullable: allow null selection
- selectedIdCallback(value): callback for option selected
- resetOnSelected: Resets selector once an option is selected. default: false
- noUnderline: remove underline if true
- value: selected value
*/
class ResourceSelector extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      options: [],
      value: this.props.value || 0,
      loading: true
    }

    this.resource = Resource(this.props.resourceAPIEndpoint)
  }

  componentWillMount() {
    const { filter } = this.props
    this.resource
      .findAll(filter)
      .then(result => this.setState({ options: result.data, loading: false }))
  }

  _change = (ev, key, value) => {
    const { selectedIdCallback, resetOnSelected } = this.props

    this.setState({ value: Number(value) }, () => {
      if (selectedIdCallback) selectedIdCallback(this.state.value)
      if (resetOnSelected) this.setState({ value: 0 })
    })
  }

  render() {
    const {
      resourcePluralName,
      unselectedLabel,
      floatingLabelText,
      nullable,
      noUnderline,
      underlineStyle
    } = this.props

    const nameAttribute = this.props.nameAttribute || 'name'

    const { loading, value, options } = this.state

    const unselectedItemLabel = unselectedLabel || `All ${resourcePluralName}`

    const noUnderlineStyle = { display: 'none' }

    // Preventing annoying warnings
    const selectProps = Object.assign({}, this.props)
    delete selectProps.resourceAPIEndpoint
    delete selectProps.resourcePluralName
    delete selectProps.nameAttribute
    delete selectProps.unselectedLabel
    delete selectProps.selectedIdCallback

    return (
      <SelectField
        value={Number(value)}
        onChange={this._change}
        underlineStyle={noUnderline ? noUnderlineStyle : underlineStyle}
        floatingLabelText={unselectedItemLabel || floatingLabelText}
        {...selectProps}
      >
        {nullable && <MenuItem value={null} primaryText="" />}

        {loading && <LinearLoader />}

        {options.map(option => (
          <MenuItem
            key={option.id}
            value={Number(option.id)}
            primaryText={option.attributes[nameAttribute]}
          />
        ))}
      </SelectField>
    )
  }
}

export default ResourceSelector



// WEBPACK FOOTER //
// ./src/components/UI/ResourceSelector.jsx